<template>
    <div class="project-applications__wrapper">
        <div class="app__card_show project-applications">
            <div class="app__card-header project-applications__card-header project-applications__title">
                {{ $tc("openApplications.availableApplications") }}
            </div>
            <div class="project-applications__filters-bar">
                <applications-search
                    :label="$tc(`applicationsFilters.search`)"
                    class="project-applications__search"
                ></applications-search>
                <applications-sorter
                    class="project-applications__sorter"
                    :fields="$settings.dataModels.PROJECT_APPLICATIONS_SORT_FIELDS"
                ></applications-sorter>
                <applications-filters
                    :applications="filteredApplications"
                    :adaptiveFilters="false"
                ></applications-filters>
                <form-checkbox-group
                    :label="$tc('applicationsFields.notInPortalOnly')"
                    @input="setNotCategorizedApplicationsFilterFlag"
                ></form-checkbox-group>
            </div>
            <diV class="project-applications__applications-list-wrapper">
                <draggable
                    class="app__project-applications-list"
                    v-model="displayedApplications"
                    :group="projectApplicationsGroup"
                >
                    <application-thumb
                        :application="application"
                        v-for="application in displayedApplications"
                        :key="application.id"
                    >
                        <template v-slot:metadata v-if="application.inProjectCategoriesCount">
                            <div class="project-applications__application-launches-counter">
                                {{ application.inProjectCategoriesCount }}
                            </div>
                        </template>
                    </application-thumb>
                </draggable>
            </diV>
        </div>
    </div>
</template>

<script>
import ApplicationsFilters from "../components/ApplicationsFilters.vue";
import ApplicationsSearch from "../components/ApplicationsSearch.vue";
import ApplicationsSorter from "../components/ApplicationsSorter.vue";
import ApplicationThumb from "./ApplicationThumb.vue";
import draggable from "vuedraggable";
import {FormCheckboxGroup, store} from "atom";
const {createNamespacedHelpers} = store;
const {mapState} = createNamespacedHelpers("arcman");

export default {
    name: "project-applications",
    components: {
        ApplicationsFilters,
        ApplicationsSearch,
        ApplicationsSorter,
        ApplicationThumb,
        draggable,
        FormCheckboxGroup,
    },
    computed: {
        ...mapState({
            filteredApplications: "filteredProjectCompatibleApplications",
        }),
        projectApplicationsGroup() {
            return {name: "projectApplicationsGroup", pull: "clone", put: false};
        },
        displayedApplications() {
            return this.notCategorizedApplicationsFilterFlag
                ? this.filteredApplications.filter(item => item.inProjectCategoriesCount === 0)
                : this.filteredApplications;
        },
    },
    data() {
        return {
            notCategorizedApplicationsFilterFlag: false,
        };
    },
    methods: {
        setNotCategorizedApplicationsFilterFlag(event) {
            this.notCategorizedApplicationsFilterFlag = event;
        },
    },
};
</script>
<style lang="scss" scoped>
.project-applications__wrapper::v-deep {
    .project-applications {
        border-color: $border-project-card-color;
    }

    .project-applications__card-header {
        background-color: $background-project-card-header-color;
    }
    .project-applications__filters-bar {
        @apply flex flex-row w-full items-end px-5 py-2;
        border-bottom: 0.125rem solid $border-filters-color;
    }

    .project-applications__search {
        @apply w-full mr-2;
        @screen lg {
            width: $search-box-width;
        }
    }

    .project-applications__sorter {
        @apply mr-2;
    }

    .project-applications__applications-list-wrapper {
        @apply overflow-auto;
        height: calc(100vh - 20.5rem);
        @screen lg {
            height: calc(100vh - 18.5rem);
        }
    }

    .project-applications__application-launches-counter {
        @apply my-1 mx-2;
    }

    .sah-form-checkbox-group {
        @apply mb-2;
    }

    .sah-form-checkbox-group__label {
        @apply block font-bold mb-3;
    }

    .sah-form-checkbox-group__input {
        @apply block w-full;
    }
}
</style>
